// extracted by mini-css-extract-plugin
export var cardIcon = "_aa-5";
export var checkboxCard = "_aa-0";
export var checkboxCardSelected = "_aa-4";
export var disabled = "_aa-2";
export var interactive = "_aa-1";
export var outerBorder = "_aa-3";
export var spacerMedium = "_aa-8";
export var spacerSmall = "_aa-7";
export var spacerXsmall = "_aa-6";